import React, { useEffect } from 'react';
import M from 'materialize-css';
import JSONPretty from 'react-json-pretty';
import { Link } from 'react-router-dom';
import { dateToFullLongDateTime } from '../../utils/DateUtil';

function Database(props) {
  const { database, onDelete } = props;
  const schemeModal = React.createRef();

  const initLoading = () => {
    let elements = document.querySelectorAll('.modal');
    M.Modal.init(elements);
  };

  useEffect(initLoading, []);

  const showScheme = () => {
    const modal = M.Modal.getInstance(schemeModal.current);
    modal.open();
  };

  const renderSchemeDialog = () => {
    return (
      <div ref={schemeModal} id="modalScheme" className="modal">
        <div className="modal-content">
          <h5>Database Scheme</h5>
          <div className="scheme-container">
            <JSONPretty id="json-pretty" data={database.schema}></JSONPretty>
          </div>
        </div>
        <div className="modal-footer">
          <a href="#close" className="modal-close waves-effect btn btn-flat">
            Cancel
          </a>
        </div>
      </div>
    );
  };

  return (
    <div className="col s12 m6">
      <div className="card z-depth-0 project-summary">
        <div className="card-content grey-text text-darken-3">
          {database.alias ? <p className="card-title">{database.alias}</p> : <p className="company-address">&nbsp;</p>}
          {database.countryCode ? <p className="company-address"> Country Code: {database.countryCode}</p> : <p className="company-address">&nbsp;</p>}
          {database.creationDate ? <p className="company-address"> Creation Date: {dateToFullLongDateTime(database.creationDate.toDate())}</p> : <p className="company-address">&nbsp;</p>}
          {database.databaseName ? <p className="company-address"> Database Name: {database.databaseName}</p> : <p className="company-address">&nbsp;</p>}
          {database.version ? <p className="company-address"> Version: {database.version}</p> : <p className="company-address">&nbsp;</p>}
          <div className="company-address">
            Scheme:{' '}
            <button className="btn-flat" onClick={(e) => showScheme()}>
              View scheme
            </button>
          </div>
        </div>
        {renderSchemeDialog()}
        <div className="card-action-disabled">
          <button className="btn-flat" onClick={(e) => onDelete(database.id, database)}>
            Delete
          </button>
          <Link
            className="btn-flat"
            to={{
              pathname: '/newDatabase',
              schemaToClone: database.schema,
            }}>
            Clone
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Database;
